import React from 'react'
import { object, string } from 'prop-types'
import CodigoPix from '../CodigoPix/CodigoPix'
import { CodigoPixWrapper, IconWrapper, MessageWrapper } from './styles'
import { ReactComponent as AlertIcon } from '../../assets/icons/alert-circle.svg'

const PendingPix = ( { pixData, message } ) => {
  if ( !pixData || !pixData.tem_cobranca_pendente ) {
    return null
  }

  const {
    'codigo_pix': codigoPix,
    'url': urlPix,
  } = pixData

  return (
    <CodigoPixWrapper>
      <MessageWrapper>
        <IconWrapper>
          <AlertIcon stroke="#B72133" />
        </IconWrapper>

        <p>
          { message }
        </p>
      </MessageWrapper>

      <CodigoPix
        codigoPix={ codigoPix }
        urlQrCode={ urlPix }
      />
    </CodigoPixWrapper>
  )
}

PendingPix.propTypes = {
  'message': string,
  'pixData': object,
}

PendingPix.defaultProps = {
  'message': null,
  'pixData': null,
}

export default PendingPix
